// 股票详情请求参数配置

import { GetocksStParams } from "../types/api-params";
import { FinancialFrequency } from "@features/api/openData";

// 详情基础数据的参数配置，对应的 QueryKey 为：layout
export const STOCK_DETAILS_LAYOUT_QUERY_PARAMS: GetocksStParams = {
  "enrich.enable": true,
  "enrich.with_trading_data": true,
  "enrich.with_recommendation_trend": true,
  "enrich.with_target_price": true,
  "enrich.with_ohlcv.enable": true,
  "enrich.with_ohlcv.period": "365d",
  "enrich.with_dividends.enable": true,
  "enrich.with_dividends.limit": 5,
};

// 价格图表请求参数配置，对应的 QueryKey 为：PRICE_CHART
export const PRICE_CHART_QUERY_PARAMS: GetocksStParams = {
  "enrich.enable": true,
  "enrich.with_sparkline.enable": true,
  "enrich.with_recommendation_trend": true,
};

// 盈利能力请求参数配置，对应的 QueryKey 为：EARNINGS
export const EARNINGS_QUERY_PARAMS: GetocksStParams = {
  "enrich.with_earnings.enable": true,
  "enrich.with_earning_scores.limit": 1,
  "enrich.with_earning_scores.enable": true,
  "enrich.with_earnings.limit": 13,
  "enrich.with_revenue_estimates.enable": true,
  "enrich.with_revenue_estimates.limit": 1,
  "enrich.enable": true,
};

// 财务报表请求参数配置，对应的 QueryKey 为：FINANCIALS
export const FINANCIALS_QUERY_PARAMS: GetocksStParams = {
  "enrich.enable": true,
  "enrich.with_financials.enable": true,
  "enrich.with_financials.statements": ["IC", "BS", "CF"],
  "enrich.with_financials.ttm": true,
  "enrich.with_revenue_breakdown.enable": true,
  "enrich.with_revenue_breakdown.freq": FinancialFrequency.Annual,
  "enrich.with_revenue_breakdown.groups": ["GEOGRAPHY", "PRODUCT"],
};

// 盈利预测请求参数配置，对应的 QueryKey 为：FORECAST
export const FORECAST_QUERY_PARAMS: GetocksStParams = {
  "enrich.enable": true,
  "enrich.with_trading_data": true,
  "enrich.with_target_price": true,
  "enrich.with_recommendation_trend": true,
  "enrich.with_ohlcv.enable": true,
  "enrich.with_ohlcv.period": "365d",
};

// 详情基础数据的参数配置，对应的 QueryKey 为：STOCK_DETAILS_MARKET
export const STOCK_DETAILS_MARKET_QUERY_PARAMS: GetocksStParams = {
  "enrich.enable": true,
  "enrich.with_trading_data": true,
  "enrich.with_ohlcv.enable": true,
  "enrich.with_recommendation_trend": true,
  "enrich.with_target_price": true,
  "enrich.with_ohlcv.period": "365d",
  "enrich.with_rating": true,
  "enrich.with_dividends.enable": true,
  "enrich.with_dividends.limit": 5,
};
